import type { AppRouteRecordRaw } from '@/router/types'
import { BLANK, LAYOUT } from '@/router/constant'
import { useI18n } from '@/hooks/web/useI18n'

const { t } = useI18n()
const KONEOnlineRoute: AppRouteRecordRaw = {
  path: '/kone-online',
  name: 'KONEOnline',
  component: LAYOUT,
  meta: {
    title: t('router.koneOnline'),
    icon: 'activity',
    perCode: 'kol:online'
  },
  children: [
    {
      path: 'product-introduce',
      name: 'ProductIntroduce',
      component: () => import('@/views/koneOnline/productIntro.vue'),
      meta: {
        title: t('router.productIntroduce'),
        master: true,
        perCode: 'ProductIntroduce'
      }
    },
    {
      path: 'project-list',
      name: 'projectList',
      component: BLANK,
      redirect: '/kone-online/project-list/index',
      meta: {
        title: t('router.projectList'),
        master: true,
        perCode: 'KONE_ONLINE_EQUIPMENT_PROJECT'
      },
      children: [
        {
          path: 'index',
          name: 'projectListIndex',
          //项目列表
          component: () => import('@/layouts/microApp/index.vue'),
          meta: {
            title: t('router.projectList'),
            microUrl: '/kol/index.html#/kol/projectList',
            path: '/#/kol/projectList'
          }
        }
      ]
    },
    {
      path: 'workOrder',
      name: 'workOrder',
      component: BLANK,
      redirect: '/kone-online/workOrder/index',
      meta: {
        title: t('router.workOrderAndEvent'),
        icon: 'kone-icon-report',
        perCode: 'KONE_ONLINE_EVENT'
      },
      children: [
        {
          path: 'index',
          name: 'workOrderIndex',
          //工单与事件
          component: () => import('@/layouts/microApp/index.vue'),
          meta: {
            title: t('router.workOrderAndEvent'),
            microUrl: '/kol/index.html#/kol/workOrder',
            path: '/#/kol/workOrder'
          }
        }
      ]
    }
  ]
}

export default KONEOnlineRoute
